import Vue from 'vue';
import axios from '../../../api/common/axios';

export default Vue.extend({
  template: '#otapedia-articles',

  data() {
    return {
      articles: []
    };
  },

  props: {
    skuLabelIds: {
      type: Array,
      required: true
    }
  },

  mounted() {
    return this.loadArticles();
  },

  methods: {
    loadArticles() {
      return axios
        .get('/otapedia/related_articles_by_sku_labels', {
          params: {
            sku_labels: this.skuLabelIds.join(',')
          }
        })
        .then((res) => {
          if (res.data.status === 'ok') {
            return (this.articles = res.data.articles);
          }
        })
        .catch(() => window.alert('Network error.'));
    }
  }
});
